import React, { Component } from "react";
import {
  Container,
  Form,
  Input,
  Row,
  Col,
  Label,
  FormGroup,
  Card,
  Button,
  CardBody,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Progress,
  FormText
} from "reactstrap";
import { appHelpers, store } from "../../_helpers";

import NotificationSystem from "react-notification-system";
import { connect } from "react-redux";
import { alertActions, commonActions, modalActions } from "../../_actions";
import { alertConstants, appConstants } from "../../_constants";
import { apiActions } from "../../_actions/api.actions";
import { commonService } from "../../_services";

//Page content util
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import SelectListComponent from "../utils/selectList";
import PageEmptyContent from "../utils/page.empty-content";
import AirlineLocationTable from "./airline-location-table";
//Icons
import AddIcon from "react-icons/lib/md/library-add";
import AirlineLocationIcon from "react-icons/lib/md/location-on";

const ViewContent = ({ children }) => (
  <div className="view-content view-components">{children}</div>
);

class AirlineLocationViewContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      airlineLocations: false,
      airports: [],
      airlines: [],
      modal: false,
      modalClass: "",
      //airline location form
      AirlineId: "",
      AirportCode: "",
      MinDailyPaxCount: "",
      MaxDailyPaxCount: "",
      MinMonthlyPaxCount: "",
      MaxMonthlyPaxCount: "",
      MinDailyFlightCount: "",
      MaxDailyFlightCount: "",
      MinMonthlyFlightCount: "",
      MaxMonthlyFlightCount: "",
      airlineLocationId: false,

      searchAirlineId: "",
      searchAirportCode: "",

      //page error
      contentError: false, //Errors that affect content on the page
      componentError: false, //Errors generated within the component
      componentErrorMessages: [], //Errors generated within the component form
      error: false, //Error state mutable via Redux
      success: false, //Success message mutable via Redux

      //    Notification
      notification: {
        // title: 'Default Title',
        message: "Default Message",
        level: "success",
        position: "tr",
        dismissible: true
      },
      createAirlineLocationEntityTypeId: null,
      updateAirlineLocationEntityTypeId: null,

      pageSize: 10,
      from: 0,
      totalCount: 0,
      currentPage: 0
    };

    this._notificationSystem = null;
    this._lastNotificationAdded = null;
  }

  componentDidMount() {
    this._notificationSystem = this.refs.notificationSystem;
    const reduxState = store.getState();
    let { desAirports, airlines, entities } = reduxState;
    const { dispatch } = this.props;

    // fetch airline locations
    // if (airlineLocations) {
    //     this.setState({
    //         airlineLocations: airlineLocations
    //     })
    // } else {
    this.fetchAirlineLocations();
    // }

    // fetch airports
    if (desAirports) {
      this.setState({
        airports: desAirports.Results
      });
    } else {
      this.fetchAirports();
    }

    // fetch airlines
    if (airlines) {
      this.setState({ airlines: airlines.Results });
    } else {
      this.fetchAirlines();
    }

    /*Check if entity type exist in store */
    if (!entities) {
      dispatch(commonActions.getEntities());
    } else {
      this.setEntityTypes(entities);
    }
  }

  componentWillReceiveProps = function(nextProps) {
    const { alert } = nextProps;
    const { modal, entities } = nextProps;

    if (alert) {
      if (alert.type === alertConstants.SUCCESS) {
        // this.setState({error: false, success: alert.message})
        this.setState({ error: false, success: "Operation successful" });
        this.resetForm();
      } else if (alert.type === alertConstants.CLEAR) {
        this.setState({ success: false, error: false });
      } else {
        this.setState({ success: false, error: alert.message });
      }
    }
    if (modal) {
      if (modal.type === appConstants.OPEN_MODAL) {
        this.setState({
          modal: true,
          modalClass: modal.modalClass
        });
      } else if (modal.type === appConstants.CLOSE_MODAL) {
        this.setState({
          modal: false,
          modalClass: modal.modalClass
        });
        this.resetForm();
      }
    }

    if (entities) {
      this.setEntityTypes(entities);
    }
  };

  fetchAirlines = () => {
    this.setState({ contentError: false });
    const { dispatch, airlines } = this.props;
    if (!airlines) {
      dispatch(apiActions.startFullPageRequest());
    } else {
      dispatch(apiActions.startRequest());
    }

    dispatch(commonActions.getAllAirlines())
      .then(() => {
        let { airlines } = this.props;
        this.setState({ airlines: airlines.Results });
        dispatch(apiActions.endRequest());
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        this.setState({ contentError: errorMessage });
        dispatch(apiActions.endRequest());
      });
  };

  fetchAirlineLocations = pageNumber => {
    this.setState({ contentError: false });
    const { dispatch } = this.props;
    const { airlineLocations, pageSize, from } = this.state;

    const payload = {
      PageSize: pageSize,
      From: from,
      Parameter: {
        AirlineId: "",
        AirportCode: ""
      }
    };

    console.log(pageNumber);
    if (pageNumber) {
      payload.From = pageSize * (pageNumber - 1);
    }

    if (!airlineLocations) {
      dispatch(apiActions.startFullPageRequest());
    } else {
      dispatch(apiActions.startRequest());
    }

    dispatch(commonActions.searchAirlineLocations(payload))
      .then(() => {
        let { airlineLocations } = this.props;
        this.setState({
          airlineLocations: airlineLocations.Results,
          totalCount: airlineLocations.TotalCount,
          currentPage: pageNumber
        });
        dispatch(apiActions.endRequest());
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        this.setState({ contentError: errorMessage });
        dispatch(apiActions.endRequest());
      });
  };

  setEntityTypes = entities => {
    let createAirlineLocationEntityTypeId;
    let updateAirlineLocationEntityTypeId;

    entities.forEach(entity => {
      if (
        entity.EntityType === appConstants.APP_ENTITIES.CREATE_AIRLINE_LOCATION
      ) {
        createAirlineLocationEntityTypeId = entity.EntityTypeId;
      } else if (
        entity.EntityType === appConstants.APP_ENTITIES.UPDATE_AIRLINE_LOCATION
      ) {
        updateAirlineLocationEntityTypeId = entity.EntityTypeId;
      }
    });
    this.setState({
      createAirlineLocationEntityTypeId,
      updateAirlineLocationEntityTypeId
    });
  };

  handleChange = (event, attribute) => {
    let currState = this.state;
    currState[attribute] = event.target.value;
    let errorMessages = this.state.componentErrorMessages;
    errorMessages[attribute] = false;
    this.setState(currState);
    this.setState({ componentErrorMessages: errorMessages });
  };

  handleSelectChange = (payload, attribute, stateAttribute) => {
    let currState = this.state;
    let errorMessages = this.state.componentErrorMessages;
    errorMessages[stateAttribute] = false;
    currState[stateAttribute] = payload ? payload[attribute] : ""; //Cater for setting up data and clearing data
    this.setState(currState);
  };

  validateInput = () => {
    let _errs_ = [];
    let formValid = true;
    if (this.state.AirlineId === "") {
      _errs_["AirlineId"] = "Please select airline";
      formValid = false;
    }

    if (this.state.AirportCode === "") {
      _errs_["AirportCode"] = "Please select airport";
      formValid = false;
    }

    if (this.state.MinDailyPaxCount === "") {
      _errs_["MinDailyPaxCount"] = "Please enter minimum daily passenger count";
      formValid = false;
    }
    if (this.state.MinDailyPaxCount < 0) {
      _errs_["MinDailyPaxCount"] = "Please enter value greater than 0";
      formValid = false;
    }

    if (this.state.MinMonthlyPaxCount === "") {
      _errs_["MinMonthlyPaxCount"] =
        "Please enter minimum monthly passenger count";
      formValid = false;
    }
    if (this.state.MinMonthlyPaxCount < 0) {
      _errs_["MinMonthlyPaxCount"] = "Please enter value greater than 0";
      formValid = false;
    }

    if (this.state.MinDailyFlightCount === "") {
      _errs_["MinDailyFlightCount"] = "Please enter minimum daily flight count";
      formValid = false;
    }
    if (this.state.MinDailyFlightCount < 0) {
      _errs_["MinDailyFlightCount"] = "Please enter a positive number";
      formValid = false;
    }

    if (this.state.MinMonthlyFlightCount === "") {
      _errs_["MinMonthlyFlightCount"] =
        "Please enter minimum monthly flight count";
      formValid = false;
    }
    if (this.state.MinMonthlyFlightCount < 0) {
      _errs_["MinMonthlyFlightCount"] = "Please enter a positive number";
      formValid = false;
    }

    if (this.state.MaxDailyPaxCount === "") {
      _errs_["MaxDailyPaxCount"] = "Please enter maximum daily passenger count";
      formValid = false;
    }
    if (this.state.MaxDailyPaxCount < 0) {
      _errs_["MaxDailyPaxCount"] = "Please enter a positive number";
      formValid = false;
    }

    if (this.state.MaxMonthlyPaxCount === "") {
      _errs_["MaxMonthlyPaxCount"] =
        "Please enter maximum monthly passenger count";
      formValid = false;
    }
    if (this.state.MaxMonthlyPaxCount < 0) {
      _errs_["MaxMonthlyPaxCount"] = "Please enter a positive number";
      formValid = false;
    }

    if (this.state.MaxDailyFlightCount === "") {
      _errs_["MaxDailyFlightCount"] = "Please enter maximum daily flight count";
      formValid = false;
    }
    if (this.state.MaxDailyFlightCount < 0) {
      _errs_["MaxDailyFlightCount"] = "Please enter a positive number";
      formValid = false;
    }

    if (this.state.MaxMonthlyFlightCount === "") {
      _errs_["MaxMonthlyFlightCount"] =
        "Please enter maximum monthly flight count";
      formValid = false;
    }
    if (this.state.MaxMonthlyFlightCount < 0) {
      _errs_["MaxMonthlyFlightCount"] = "Please enter a positive number";
      formValid = false;
    }

    this.setState({ componentErrorMessages: _errs_ });
    return formValid;
  };

  notify = (message, level) => {
    let notification = this.state.notification;
    notification["message"] = message;
    notification["level"] = level;
    notification.onRemove = this.onRemove;
    this._lastNotificationAdded = this._notificationSystem.addNotification(
      notification
    );
  };

  onRemove = notification => {
    if (
      this._lastNotificationAdded &&
      notification.uid === this._lastNotificationAdded.uid
    ) {
      this._lastNotificationAdded = null;
    }
  };

  resetForm() {
    this.setState({
      componentError: false,
      componentErrorMessages: [],
      AirlineId: "",
      AirportCode: "",
      MinDailyPaxCount: "",
      MaxDailyPaxCount: "",
      MinMonthlyPaxCount: "",
      MaxMonthlyPaxCount: "",
      MinDailyFlightCount: "",
      MaxDailyFlightCount: "",
      MinMonthlyFlightCount: "",
      MaxMonthlyFlightCount: "",
      airlineLocationId: false
    });
    this.resetError();
  }

  resetSearchForm = () => {
    this.setState({
      searchAirlineId: "",
      searchAirportCode: ""
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    this.setState({ isRequesting: true });
    this.resetError();
    if (this.validateInput()) {
      this.processSubmit();
    }
  };

  resetError() {
    this.props.dispatch(modalActions.clear());
    this.props.dispatch(alertActions.clear());
  }

  processSubmit = () => {
    let {
      airlineLocationId,
      AirlineId,
      AirportCode,
      MinDailyFlightCount,
      MinDailyPaxCount,
      MinMonthlyFlightCount,
      MinMonthlyPaxCount,
      MaxDailyFlightCount,
      MaxDailyPaxCount,
      MaxMonthlyFlightCount,
      MaxMonthlyPaxCount
    } = this.state;
    const userRole = appHelpers.getActiveUser().AviRole;

    let payload = {
      AirlineId: AirlineId,
      AirportCode: AirportCode,
      MinDailyPaxCount: MinDailyPaxCount,
      MinMonthlyPaxCount: MinMonthlyPaxCount,
      MinDailyFlightCount: MinDailyFlightCount,
      MinMonthlyFlightCount: MinMonthlyFlightCount,
      MaxDailyPaxCount: MaxDailyPaxCount,
      MaxMonthlyPaxCount: MaxMonthlyPaxCount,
      MaxDailyFlightCount: MaxDailyFlightCount,
      MaxMonthlyFlightCount: MaxMonthlyFlightCount
    };
    if (airlineLocationId) {
      payload.Id = airlineLocationId;
    }

    if (userRole === appConstants.ROLES.VGG_ADMIN) {
      this.createMakerChecker(payload);
    } else {
      this.createAirlineLocation(payload);
    }
  };

  createAirlineLocation = payload => {
    const { dispatch } = this.props;

    dispatch(apiActions.startRequest());
    commonService.createAirlineLocation(payload).then(res => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        this.toggle(null, "modalSlide");
        let msg = payload.Id
          ? "Airport location updated successfully"
          : "Airport location created successfully";
        this.notify(msg, appConstants.NOTIFY_SUCCESS);
        dispatch(apiActions.endRequest());
        this.resetSearchForm();
        this.fetchAirlineLocations();
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
        dispatch(apiActions.endRequest());
      }
    });
  };

  createMakerChecker = payload => {
    const { dispatch } = this.props;
    const {
      airlineLocationId,
      createAirlineLocationEntityTypeId,
      updateAirlineLocationEntityTypeId,
      AirlineId,
      AirportCode,
      MinDailyFlightCount,
      MinDailyPaxCount,
      MinMonthlyFlightCount,
      MinMonthlyPaxCount,
      MaxDailyFlightCount,
      MaxDailyPaxCount,
      MaxMonthlyFlightCount,
      MaxMonthlyPaxCount
    } = this.state;
    const { authentication } = store.getState();

    /*Maker Checker */
    let payloadTemplate = {
      Airline: this.interpretAirline(AirlineId),
      Airport: this.interpretAirport(AirportCode),
      "Minimum Daily Passenger Count": MinDailyPaxCount,
      "Maximum Daily Passenger Count": MaxDailyPaxCount,
      "Minimum Monthly Passenger Count": MinMonthlyPaxCount,
      "Maximum Monthly Passenger Count": MaxMonthlyPaxCount,
      "Minimum Daily Flight Count": MinDailyFlightCount,
      "Maximum Daily Flight Count": MaxDailyFlightCount,
      "Minimum Monthly Flight Count": MinMonthlyFlightCount,
      "Maximum Monthly Flight Count": MaxMonthlyFlightCount
    };

    // TODO: Add URL endpoint
    let makerCheckerPayload = {
      AppId: appConstants.MAKER_CHECKER_APP_ID,
      Payload: JSON.stringify(payload),
      PayloadViewTemplate: JSON.stringify(payloadTemplate),
      URL: `${
        appConstants.PAS_URL
      }/api/AirlineMetrics/SaveAirlineLocationDetails`,
      EntityTypeId: createAirlineLocationEntityTypeId,
      CreatedBy: authentication.user.userName
    };
    if (airlineLocationId) {
      makerCheckerPayload.EntityTypeId = updateAirlineLocationEntityTypeId;
    }

    dispatch(apiActions.startRequest());
    commonService.createMakerChecker(makerCheckerPayload).then(res => {
      if (res.status === appConstants.SUCCESS_RESPONSE) {
        this.toggle(null, "modalSlide");
        let msg = payload.Id
          ? "Airport location update sent successfully"
          : "Airport location creation sent successfully";
        this.notify(msg, appConstants.NOTIFY_SUCCESS);
        dispatch(apiActions.endRequest());
      } else if (res.status === appConstants.ERROR_RESPONSE) {
        dispatch(alertActions.error(res.response));
        dispatch(apiActions.endRequest());
      }
    });
  };

  fetchAirports = () => {
    this.setState({ contentError: false });
    const { dispatch, desAirports } = this.props;

    if (!desAirports) {
      dispatch(apiActions.startFullPageRequest());
    } else {
      dispatch(apiActions.startRequest());
    }

    dispatch(commonActions.getDesAirports())
      .then(() => {
        let { desAirports } = this.props;
        this.setState({ airports: desAirports.Results });
        dispatch(apiActions.endRequest());
      })
      .catch(error => {
        let errorMessage = appHelpers.interpretErrorResponse(error);
        this.notify(errorMessage, appConstants.NOTIFY_ERROR);
        this.setState({ contentError: errorMessage });
        dispatch(apiActions.endRequest());
      });
  };

  passAirlineLocationDetails = airlineLocation => {
    this.setState({
      airlineLocationId: airlineLocation.Id,
      AirlineId: airlineLocation.AirlineId ? airlineLocation.AirlineId : "",
      AirportCode: airlineLocation.AirportCode
        ? airlineLocation.AirportCode
        : "",
      MinDailyPaxCount: airlineLocation.MinDailyPaxCount
        ? airlineLocation.MinDailyPaxCount
        : "",
      MinMonthlyPaxCount: airlineLocation.MinMonthlyPaxCount
        ? airlineLocation.MinMonthlyPaxCount
        : "",
      MaxDailyPaxCount: airlineLocation.MaxDailyPaxCount
        ? airlineLocation.MaxDailyPaxCount
        : "",
      MaxMonthlyPaxCount: airlineLocation.MaxMonthlyPaxCount
        ? airlineLocation.MaxMonthlyPaxCount
        : "",
      MinDailyFlightCount: airlineLocation.MinDailyFlightCount
        ? airlineLocation.MinDailyFlightCount
        : "",
      MinMonthlyFlightCount: airlineLocation.MinMonthlyFlightCount
        ? airlineLocation.MinMonthlyFlightCount
        : "",
      MaxDailyFlightCount: airlineLocation.MaxDailyFlightCount
        ? airlineLocation.MaxDailyFlightCount
        : "",
      MaxMonthlyFlightCount: airlineLocation.MaxMonthlyFlightCount
        ? airlineLocation.MaxMonthlyFlightCount
        : ""
    });
    this.toggle(null, "modalSlideIn");
  };

  toggle = (e, modalClass) => {
    if (this.state.modal) {
      this.resetForm();
      this.props.dispatch(modalActions.close({ modalClass: modalClass }));
    } else {
      this.props.dispatch(modalActions.open({ modalClass: modalClass }));
    }
  };

  toggleCheckbox = attribute => {
    let currState = this.state;
    currState[attribute] = !currState[attribute];
    this.setState(currState);
  };

  renderPageResponse() {
    if (this.state.error) {
      return <div className="alert alert-danger">{this.state.error}</div>;
    } else if (this.state.componentError) {
      return (
        <div className="alert alert-danger">{this.state.componentError}</div>
      );
    } else if (this.state.success) {
      return <div className="alert alert-success">{this.state.success}</div>;
    }
  }

  interpretAirline(airlineId) {
    const { Results } = this.props.airlines;
    if (Results) {
      const airlineName = Results.find(airline => airline.Id === airlineId);
      if (airlineName) return airlineName.Name;
    }
  }

  interpretAirport(airportCode) {
    const { Results } = this.props.desAirports;
    if (Results) {
      const airportName = Results.find(airport => airport.Code === airportCode);
      if (airportName) return airportName.Name;
    }
  }

  handleAirportCodeChange = target => {
    const { from, pageSize, searchAirlineId, searchAirportCode } = this.state;
    if (!(target === null && searchAirportCode === "")) {
      let airportCode = target ? target.Code : "";
      this.setState({ contentError: false, searchAirportCode: airportCode });
      const { dispatch } = this.props;
      const payload = {
        PageSize: pageSize,
        From: from,
        Parameter: {
          AirlineId: searchAirlineId,
          AirportCode: airportCode
        }
      };
      dispatch(apiActions.startRequest());
      dispatch(commonActions.searchAirlineLocations(payload))
        .then(() => {
          let { airlineLocations } = this.props;
          this.setState({ airlineLocations: airlineLocations.Results });
          dispatch(apiActions.endRequest());
        })
        .catch(error => {
          let errorMessage = appHelpers.interpretErrorResponse(error);
          this.notify(errorMessage, appConstants.NOTIFY_ERROR);
          this.setState({ contentError: errorMessage });
          dispatch(apiActions.endRequest());
        });
    }
  };

  handleAirlineChange = target => {
    const { from, pageSize, searchAirportCode, searchAirlineId } = this.state;

    if (!(target === null && searchAirlineId === "")) {
      let airlineId = target ? target.Id : "";
      this.setState({ contentError: false, searchAirlineId: airlineId });
      const { dispatch } = this.props;
      const payload = {
        PageSize: pageSize,
        From: from,
        Parameter: {
          AirlineId: airlineId,
          AirportCode: searchAirportCode
        }
      };

      dispatch(apiActions.startRequest());
      dispatch(commonActions.searchAirlineLocations(payload))
        .then(() => {
          let { airlineLocations } = this.props;
          this.setState({ airlineLocations: airlineLocations.Results });
          dispatch(apiActions.endRequest());
        })
        .catch(error => {
          let errorMessage = appHelpers.interpretErrorResponse(error);
          this.notify(errorMessage, appConstants.NOTIFY_ERROR);
          this.setState({ contentError: errorMessage });
          dispatch(apiActions.endRequest());
        });
    }
  };

  render() {
    let modalResponse = this.renderPageResponse();
    const { requesting } = this.props;
    const { pageRequesting } = this.props;
    const {
      contentError,
      airports,
      airlines,
      airlineLocations,
      componentErrorMessages,
      totalCount,
      currentPage,
      pageSize,
      airlineLocationId
    } = this.state;
    let airlineLocationsLength = airlineLocations ? airlineLocations.length : 0;
    return (
      <div className="view">
        <ViewContent>
          <Card className="mb-4">
            {/*Progress bar for Pending API Request*/}
            {(pageRequesting || requesting) && !pageRequesting && (
              <Progress
                animated
                striped
                color="success"
                value={100}
                className="mb-2"
              />
            )}

            {/*Display loader when component content is dependent on Data from API*/}
            {!contentError && pageRequesting && <PageLoading />}

            {/*Display error when component fail to get Data from API*/}
            {contentError && <PageError error={this.state.contentError} />}

            {/*Display component content when Data is gotten from API*/}
            {!contentError && !pageRequesting && (
              <CardBody className="table-responsive">
                <div className="row">
                  <h6 className="mb-4 col-md-8 text-uppercase pull-left">
                    Airline Locations
                    <FormText color="muted">
                      {totalCount > 0 && (
                        <div>
                          <AirlineLocationIcon size="18" color="#43a8df" />
                          &nbsp;
                          <span>
                            {totalCount}&nbsp;
                            {totalCount === 1
                              ? "airline location found"
                              : "airline locations found"}
                          </span>
                        </div>
                      )}
                    </FormText>
                  </h6>
                  <div className="mb-4 col-md-4 text-right">
                    <Button
                      className="btn-avi-primary"
                      onClick={e => this.toggle(e, "modalSlideIn")}
                    >
                      <AddIcon color="#ffffff" size="18" />
                      &nbsp;Create Airline Location
                    </Button>{" "}
                  </div>
                </div>

                <div>
                  <Form onSubmit={this.fetchAirports}>
                    <Row>
                      <Col sm="4">
                        <FormGroup className="mb-4">
                          <SelectListComponent
                            placeholder={"Select airline..."}
                            data={airlines}
                            valueKey="Id"
                            textField="Name"
                            selectValue={this.state.searchAirlineId}
                            onValueChange={payload =>
                              this.handleAirlineChange(payload)
                            }
                          />
                        </FormGroup>
                      </Col>
                      <Col sm="4">
                        <FormGroup className="mb-4">
                          <SelectListComponent
                            placeholder={"Select airport..."}
                            data={airports}
                            valueKey="Code"
                            textField="Name"
                            selectValue={this.state.searchAirportCode}
                            onValueChange={payload =>
                              this.handleAirportCodeChange(payload)
                            }
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                  </Form>
                </div>

                {!pageRequesting && airlineLocationsLength > 0 && (
                  <AirlineLocationTable
                    data={airlineLocations}
                    editCallback={this.passAirlineLocationDetails}
                    pageDataCallback={this.fetchAirlineLocations}
                    totalCount={totalCount}
                    currentPage={currentPage}
                    pageSize={pageSize}
                    // interpretAirline={this.interpretAirline}
                    // interpretAirport = {this.interpretAirport}
                  />
                )}

                {!pageRequesting && airlineLocationsLength === 0 && (
                  <PageEmptyContent message="No airline location found!" />
                )}

                <Modal
                  isOpen={this.state.modal}
                  toggle={this.toggle}
                  className={this.state.modalClass}
                >
                  <ModalHeader toggle={this.toggle}>
                    {airlineLocationId ? "Edit" : "Create"} Airline Location
                  </ModalHeader>
                  <Form onSubmit={this.handleSubmit}>
                    <ModalBody>
                      {modalResponse}
                      <Container>
                        <Row>
                          <Col sm="12">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages.AirlineId
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label>Airline</Label>
                              <SelectListComponent
                                disabled={airlineLocationId ? true : false}
                                data={airlines}
                                valueKey="Id"
                                textField="Name"
                                selectValue={this.state.AirlineId}
                                onValueChange={payload =>
                                  this.handleSelectChange(
                                    payload,
                                    "Id",
                                    "AirlineId"
                                  )
                                }
                              />
                              {componentErrorMessages.AirlineId && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.AirlineId}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                      </Container>

                      <Container>
                        <Row>
                          <Col sm="12">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages.AirportCode
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label>Airport</Label>
                              <SelectListComponent
                               disabled={airlineLocationId ? true : false}
                                data={airports}
                                valueKey="Code"
                                textField="Name"
                                selectValue={this.state.AirportCode}
                                onValueChange={payload =>
                                  this.handleSelectChange(
                                    payload,
                                    "Code",
                                    "AirportCode"
                                  )
                                }
                              />
                              {componentErrorMessages.AirportCode && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.AirportCode}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                      </Container>

                      <Container>
                        <Row>
                          <Col sm="6">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages
                                  .MinDailyPaxCount
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label>Minimum Daily Passenger Count</Label>
                              <Input
                                type="number"
                                placeholder=""
                                value={this.state.MinDailyPaxCount}
                                onChange={event =>
                                  this.handleChange(event, "MinDailyPaxCount")
                                }
                              />
                              {componentErrorMessages.MinDailyPaxCount && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.MinDailyPaxCount}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>

                          <Col sm="6">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages
                                  .MaxDailyPaxCount
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label>Maximum Daily Passenger Count</Label>
                              <Input
                                type="number"
                                placeholder=""
                                value={this.state.MaxDailyPaxCount}
                                onChange={event =>
                                  this.handleChange(event, "MaxDailyPaxCount")
                                }
                              />
                              {componentErrorMessages.MaxDailyPaxCount && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.MaxDailyPaxCount}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                      </Container>

                      <Container>
                        <Row>
                          <Col sm="6">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages
                                  .MinMonthlyPaxCount
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label>Minimum Monthly Passenger Count</Label>
                              <Input
                                type="number"
                                placeholder=""
                                value={this.state.MinMonthlyPaxCount}
                                onChange={event =>
                                  this.handleChange(event, "MinMonthlyPaxCount")
                                }
                              />
                              {componentErrorMessages.MinMonthlyPaxCount && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.MinMonthlyPaxCount}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>

                          <Col sm="6">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages
                                  .MaxMonthlyPaxCount
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label>Maximum Monthly Passenger Count</Label>
                              <Input
                                type="number"
                                placeholder=""
                                value={this.state.MaxMonthlyPaxCount}
                                onChange={event =>
                                  this.handleChange(event, "MaxMonthlyPaxCount")
                                }
                              />
                              {componentErrorMessages.MaxMonthlyPaxCount && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.MaxMonthlyPaxCount}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                      </Container>

                      <Container>
                        <Row>
                          <Col sm="6">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages
                                  .MinDailyFlightCount
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label>Minimum Daily Flight Count</Label>
                              <Input
                                type="number"
                                placeholder=""
                                value={this.state.MinDailyFlightCount}
                                onChange={event =>
                                  this.handleChange(
                                    event,
                                    "MinDailyFlightCount"
                                  )
                                }
                              />
                              {componentErrorMessages.MinDailyFlightCount && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.MinDailyFlightCount}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>
                          <Col sm="6">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages
                                  .MaxDailyFlightCount
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label>Maximum Daily Flight Count</Label>
                              <Input
                                type="number"
                                placeholder=""
                                value={this.state.MaxDailyFlightCount}
                                onChange={event =>
                                  this.handleChange(
                                    event,
                                    "MaxDailyFlightCount"
                                  )
                                }
                              />
                              {componentErrorMessages.MaxDailyFlightCount && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.MaxDailyFlightCount}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                      </Container>

                      <Container>
                        <Row>
                          <Col sm="6">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages
                                  .MinMonthlyFlightCount
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label>Minimum Monthly Flight Count</Label>
                              <Input
                                type="number"
                                placeholder=""
                                value={this.state.MinMonthlyFlightCount}
                                onChange={event =>
                                  this.handleChange(
                                    event,
                                    "MinMonthlyFlightCount"
                                  )
                                }
                              />
                              {componentErrorMessages.MinMonthlyFlightCount && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.MinMonthlyFlightCount}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>
                          <Col sm="6">
                            <FormGroup
                              className={
                                "mb-4 " +
                                (this.state.componentErrorMessages
                                  .MaxMonthlyFlightCount
                                  ? "has-danger"
                                  : "")
                              }
                            >
                              <Label>Maximum Monthly Flight Count</Label>
                              <Input
                                type="number"
                                placeholder=""
                                value={this.state.MaxMonthlyFlightCount}
                                onChange={event =>
                                  this.handleChange(
                                    event,
                                    "MaxMonthlyFlightCount"
                                  )
                                }
                              />
                              {componentErrorMessages.MaxMonthlyFlightCount && (
                                <FormText color="danger">
                                  {" "}
                                  {componentErrorMessages.MaxMonthlyFlightCount}
                                </FormText>
                              )}
                            </FormGroup>
                          </Col>
                        </Row>
                      </Container>
                    </ModalBody>
                    <ModalFooter>
                      <Button className="btn-avi-primary" disabled={requesting}>
                        {" "}
                        Proceed{" "}
                      </Button>{" "}
                      <Button color="secondary" onClick={this.toggle}>
                        Cancel
                      </Button>
                    </ModalFooter>
                  </Form>
                  {requesting && <div className={"loading-dot active"} />}
                </Modal>
              </CardBody>
            )}
            <NotificationSystem ref="notificationSystem" />
          </Card>
        </ViewContent>
      </div>
    );
  }
}
function mapStateToProps(state, ownProps) {
  const { loggingIn } = state.authentication;
  const { requesting, pageRequesting } = state.api;
  const {
    alert,
    modal,
    desAirports,
    entities,
    airlineLocations,
    airlines
  } = state;
  return {
    loggingIn,
    requesting,
    pageRequesting,
    modal,
    alert,
    desAirports,
    entities,
    airlineLocations,
    airlines
  };
}
export default connect(mapStateToProps)(AirlineLocationViewContent);



// WEBPACK FOOTER //
// ./src/views/airline-location/view-content.js